<style scoped lang="scss" type="text/scss">

</style>

<template>
    <div class="global-relative">
        <loading-placeholder :loading="requesting"></loading-placeholder>
        <el-table :data="internalMessages" stripe border size="small" style="width: 100%">
            <el-table-column type="index" :index="indexMethod" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="title" label="标题" align="center" min-width="300"></el-table-column>
            <el-table-column prop="sender_name" label="发件人" align="center" min-width="80"></el-table-column>
            <el-table-column prop="create_time_text" label="发件时间" align="center" min-width="100"></el-table-column>
            <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" plain @click="detail(scope.row)">
                        查看详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination :page-size="pageSize" :current-page.sync="currentPage" :total="total"
                    @current-change="loadUnreadInternalMessages">
        </pagination>

        <detail-popup :visible.sync="visible" :info="activeInternalMessage"></detail-popup>
    </div>
</template>

<script>
    import DetailPopup from './detail-popup';
    import {handleInternalMessages} from '../../../utils/data-handler';
    import {indexMethod, updatePageOption} from '../../../utils/page';

    export default {
        name: '',
        components: {
            DetailPopup
        },
        created () {
            this.loadUnreadInternalMessages();
            this.reloadInternalMessagesNumber();
        },
        data () {
            return {
                internalMessages: [],
                requesting: false,
                visible: false,
                activeInternalMessage: {},
                pageSize: 10,
                total: 0,
                currentPage: 1
            };
        },
        computed: {
            page () {
                return {
                    page_size: this.pageSize,
                    page_num: this.currentPage
                };
            }
        },
        methods: {
            indexMethod (index) {
                return indexMethod(index, this);
            },
            detail (info) {
                this.activeInternalMessage = info;
                this.visible = true;
                this.readInternalMessages(info.id);
            },
            loadUnreadInternalMessages () {
                this.$normalRequest('user/loadUnreadInternalMessages', {
                    ...this.page
                }, false, false, this, 'requesting').then(data => {
                    updatePageOption(this, data);
                    this.internalMessages = handleInternalMessages(data.list);
                }).catch(_ => {
                });
            },
            readInternalMessages (id) {
                this.$normalRequest('user/readInternalMessages', {
                    id: id
                }, false, true, this, 'requesting').then(_ => {
                    this.reloadInternalMessagesNumber();
                }).catch(_ => {
                });
            },
            reloadInternalMessagesNumber () {
                this.$store.dispatch('user/loadUnreadInternalMessagesNumber').then();
            }
        }
    };
</script>
